import axios from 'axios';

const firebaseInstance = axios.create({
    baseURL:'https://portfolio-f80c5.firebaseio.com/'
});

export default firebaseInstance;


// WEBPACK FOOTER //
// ./src/firebase-axios.js